
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquare, Users, BarChart, Settings, CheckSquare } from "lucide-react";
import { CloseActivities } from "./CloseActivities";
import { CloseLeads } from "./CloseLeads";
import { CloseOpportunities } from "./CloseOpportunities";
import { CloseTasks } from "./CloseTasks";
import { CloseSettings } from "./CloseSettings";
import { CloseConnectionStatus } from "./CloseConnectionStatus";
import { useToast } from "@/hooks/use-toast";

export const CloseDashboard = () => {
  const [activeTab, setActiveTab] = useState("leads");
  const { toast } = useToast();

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    if (value === "leads") {
      toast.default({
        title: "Leads geladen",
        description: "Die aktuellen Leads wurden erfolgreich geladen."
      });
    }
  };

  return (
    <div className="flex flex-col w-full h-full">
      <div className="p-4 md:p-6 border-b border-gray-800/10 bg-white/50 backdrop-blur-sm">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-4">
          <div>
            <h2 className="text-2xl font-medium tracking-tight mb-2 flex items-center gap-2">
              <MessageSquare className="text-[#41c7f0]" size={24} />
              <span className="text-hossTeal">Close CRM</span>
            </h2>
            <p className="text-gray-600 leading-relaxed">Kundendaten und Vertriebsaktivitäten verwalten</p>
          </div>
          
          <CloseConnectionStatus />
        </div>
      </div>

      <div className="p-4 md:p-6 flex-1 overflow-hidden flex flex-col">
        <Tabs
          defaultValue="leads"
          value={activeTab}
          onValueChange={handleTabChange}
          className="w-full flex-1 flex flex-col"
        >
          <TabsList className="grid grid-cols-5 w-full max-w-3xl mb-4 bg-[#081426] p-1 border border-gray-700">
            <TabsTrigger value="leads" className="flex items-center gap-2">
              <Users size={16} />
              <span className="hidden sm:inline">Leads</span>
            </TabsTrigger>
            <TabsTrigger value="opportunities" className="flex items-center gap-2">
              <BarChart size={16} />
              <span className="hidden sm:inline">Opportunities</span>
            </TabsTrigger>
            <TabsTrigger value="activities" className="flex items-center gap-2">
              <MessageSquare size={16} />
              <span className="hidden sm:inline">Aktivitäten</span>
            </TabsTrigger>
            <TabsTrigger value="tasks" className="flex items-center gap-2">
              <CheckSquare size={16} />
              <span className="hidden sm:inline">Tasks</span>
            </TabsTrigger>
            <TabsTrigger value="settings" className="flex items-center gap-2">
              <Settings size={16} />
              <span className="hidden sm:inline">Einstellungen</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="leads" className="flex-1 overflow-hidden">
            <CloseLeads />
          </TabsContent>
          
          <TabsContent value="opportunities" className="flex-1 overflow-auto">
            <CloseOpportunities />
          </TabsContent>
          
          <TabsContent value="activities" className="flex-1 overflow-auto">
            <CloseActivities />
          </TabsContent>
          
          <TabsContent value="tasks" className="flex-1 overflow-auto">
            <CloseTasks />
          </TabsContent>
          
          <TabsContent value="settings" className="flex-1 overflow-auto">
            <CloseSettings />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};
